<template>
    <span id="waiting-area-delete">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-action btn-danger btn-sm mb-2" data-toggle="modal"
            :data-target="getDataTarget()"><i class="fas fa-trash"></i></button>

        <!-- Modal -->
        <div class="modal fade text-left" :id="getModalId()" tabindex="-1" aria-labelledby="waitingAreaDeleteLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="waitingAreaDeleteLabel">Delete Waiting Area</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Are you sure you want to <b>delete</b> the waiting area <b>{{ waitingArea.waitingArea }}</b>?
                        This action cannot be undone!
                        Please click confirm to proceed.
                    </div>
                    <div class="modal-footer">
                        <button v-if="loading" type="button" class="btn btn-danger" disabled>Deleting <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-danger"
                            @click="deleteWaitingArea()">Confirm</button>
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'waiting-area-delete',
    props: {
        waitingArea: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        deleteWaitingArea() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?deletewaitingAreasData&id=${this.waitingArea.id}`;

            // Set loading
            this.loading = true;

            // POST request
            fetch(api).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    // Success
                    that.$emit('setAlert', `${that.waitingArea.waitingArea} has been successfully been deleted.`, true, 'success');
                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.$emit('setAlert', `${that.waitingArea.waitingArea} could not be deleted. ${json.message}.`, true, 'warning');
                } else {
                    // Internal error
                    that.$emit('setAlert', `${that.waitingArea.waitingArea} could not be deleted. An error has occurred. Please contact your system administrator.`, true, 'danger');
                }

                that.refreshData();
                that.loading = false;
                $(`#waitingAreaDelete-${that.waitingArea.id}`).modal('hide');
            }).catch(function () {
                // Internal error
                that.$emit('setAlert', `${that.waitingArea.waitingArea} could not be deleted. An error has occurred. Please contact your system administrator.`, true, 'danger');
                that.loading = false;
                $(`#waitingAreaDelete-${that.waitingArea.id}`).modal('hide');
            })
        },
        getDataTarget() {
            return `#waitingAreaDelete-${this.waitingArea.id}`;
        },
        getModalId() {
            return `waitingAreaDelete-${this.waitingArea.id}`;
        },
        refreshData() {
            this.$emit('refreshData');
        }
    }
}
</script>